import TextImage from "../../../UI/TextImage/TextImage";
import mainImage from "../../../../assets/HomePage/GrowBusinessImg.png";

const GrowBusiness = (props) => {
  return (
    <TextImage
      imageThenText={true}
      header={"Community & Conversations."}
      paragraph={`Being a founder can be lonely, but it doesn’t have to be. Meet and interact with others in the community, both through our private Slack channel and community-wide networking events.`}
      src={mainImage}
      alt={"Grow Business"}
      maxWidth={{ maxWidth: "250px" }}
    />
  );
};

export default GrowBusiness;
